import { useState, useEffect, useRef } from 'react';

import SearchIcon from 'assets/icons/search.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Button } from 'ui';

import s from './SearchForm.module.scss';

const cx = cn.bind(s);

const SearchForm = ({
  children,
  initialSearch = '',
  hasSubmitButton,
  className,
  iconSize = '',
  isLoading,
  onChange,
  onSubmit,
  ...attrs
}) => {
  const [search, setSearch] = useState(initialSearch);
  const formRef = useRef(null);
  const handleChange = (ev) => {
    const { value } = ev.target;
    if (onChange) {
      onChange(value);
    }
    setSearch(value);
  };
  const handleSubmit = (ev) => {
    ev.preventDefault();
    if (onSubmit) {
      onSubmit(search);
    }
  };
  const submit = () => {
    if (formRef.current) {
      formRef.current.submit();
    }
  };
  useEffect(() => {
    setSearch(initialSearch);
  }, [initialSearch]);

  return (
    <form className={cx(className, 'form')} ref={formRef} {...attrs} onSubmit={handleSubmit}>
      <div className={cx('formInner')}>
        <div className={cx('fieldContainer', { withOffsetContainer: hasSubmitButton })}>
          <input
            value={search}
            type="text"
            placeholder="Type keywords"
            className={cx('input')}
            onChange={handleChange}
          />
          <button
            type="submit"
            className={cx('icon', {
              [`icon_${iconSize}`]: !!iconSize,
            })}
          >
            <SearchIcon />
          </button>
        </div>
        {hasSubmitButton && (
          <Button type="submit" size="small" disabled={isLoading} onClick={handleSubmit}>
            Search
          </Button>
        )}
      </div>
      {children
        && children({
          submit,
        })}
    </form>
  );
};

SearchForm.propTypes = {
  initialSearch: PropTypes.string,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  hasSubmitButton: PropTypes.bool,
  isLoading: PropTypes.bool,
  iconSize: PropTypes.oneOf(['large', '']),
};

export default SearchForm;
